import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { deleteCoupon, getCoupons } from '../../store/actions/coupon/coupon.action';
import CouponsList from '../../components/Coupons/Coupons';
import PageLoader from '../../components/Common/PageLoader';

const CouponsContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const isCreating = useSelector((state) => state.coupon.isCreating);
  const coupons = useSelector((state) => state.coupon.list);
  const isFetching = useSelector((state) => state.coupon.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const couponCategory = categories.find((category) => category.link === 'coupons');
      if (couponCategory) {
        setMode(couponCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Coupon category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Handle delete coupon
  const handleDeleteCoupon = useCallback((coupon) => {
    dispatch(deleteCoupon(coupon));
  }, [dispatch]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getCoupons());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare coupon info object
  const couponInfo = {
    deleteCoupon: handleDeleteCoupon,
    coupons
  };

  return (
    <section>
      <CouponsList mode={mode} couponInfo={couponInfo} />
    </section>
  );
};

export default CouponsContainer;
